// @flow
import React, { Component } from 'react';
import {
  BoxNavLink,
  RegistrationMethodsDiv
} from './MerchantRegistrationsStyles';
import { Mobile, Default } from '../../../components/Responsive';

type Props = {
  isFormActive: () => boolean
};

export default class RegistrationMethodsNav extends Component<Props> {
  render() {
    return (
      <div>
        <RegistrationMethodsDiv>
          <BoxNavLink
            // strict
            to="/merchants/registrations/form/1"
            isActive={this.props.isFormActive}
          >
            <Mobile>
              <h5>Via Form</h5>
            </Mobile>
            <Default>
              <h5>Sign Up Form</h5>
            </Default>
            <p>
              Our sign up form is a simple intuitive way for you to go through
              the registration process and add merchants one by one.
            </p>
          </BoxNavLink>
          <BoxNavLink exact to="/merchants/registrations/csv">
            <h5>
              <Default>Import </Default>Via CSV
            </h5>
            <p>
              This is best suited for you to register multiple merchants. Upload
              a CSV file with all your merchants information and our system will
              do the rest.
            </p>
          </BoxNavLink>
          <BoxNavLink to="/merchants/registrations/api">
            <h5>
              <Default>Import</Default> Via API
            </h5>
            <p>
              Import your new merchants via our API, our API documentation will
              guide you through the process.
            </p>
          </BoxNavLink>
        </RegistrationMethodsDiv>
      </div>
    );
  }
}
